import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "generate-workplan-modal-evs";

const keys = addTranslations(RESOURCE_NAME, {
    open_button: {
        en: "Export Workplan",
        fr: "Exporter un plan de travail",
    },
    generate_workplan: {
        en: "Generate Workplan",
        fr: "Générer un plan de travail",
    },

    generate_workplan_description: {
        en: "This agent will generate a workplan based on your results of your previous Ecovadis questionnaire. Please upload your scorecards pdfs and select the corresponding theme to each of your scorecards.",
        fr: "Cet agent générera un plan de travail basé sur vos résultats de votre questionnaire Ecovadis. Veuillez télécharger vos scorecards pdf et sélectionner le thème correspondant à chacune de vos scorecards.",
    },
    upload_evs_scorecards: {
        en: "Upload Ecovadis Scorecards",
        fr: "Télécharger les scorecards Ecovadis",
    },
    generate_workplan_success: {
        en: "Your workplan is generating. You will receive an email with the link to the workplan.",
        fr: "Votre plan de travail est en cours de génération. Vous recevrez un email avec le lien vers le plan de travail.",
    },
    generate_workplan_error: {
        en: "An error occurred while generating your workplan. Please try again later.",
        fr: "Une erreur est survenue lors de la génération de votre plan de travail. Veuillez réessayer plus tard.",
    },
    select_theme: {
        en: "Select Theme",
        fr: "Sélectionner un thème",
    },
    select_theme_description: {
        en: "Select the corresponding theme to each of your scorecards.",
        fr: "Choisissez le thème correspondant à chacune de vos scorecards.",
    },
    cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    generate_workplan_button: {
        en: "Generate Workplan",
        fr: "Générer un plan de travail",
    },
    generate_workplan_tooltip: {
        en: "Please upload 4 scorecards and select the corresponding theme to each of your scorecards. One scorecard per theme and all themes must be used.",
        fr: "Veuillez télécharger 4 scorecards et sélectionner le thème correspondant à chacune de vos scorecards. Un scorecard par thématique et toutes les thématiques doivent être utilisées.",
    },
    theme_environment: {
        en: "Environment",
        fr: "Environnement",
    },
    theme_ethics: {
        en: "Ethics",
        fr: "Ethique",
    },
    theme_procurement: {
        en: "Procurement",
        fr: "Achats Responsables",
    },
    theme_social: {
        en: "Social",
        fr: "Social",
    },
    theme_ecovadis_questionnaire: {
        en: "Ecovadis Questionnaire",
        fr: "Questionnaire Ecovadis",
    },
    select_language: {
        en: "Select the language of your documents",
        fr: "Sélectionner la langue de vos documents",
    },
});

export function useGenerateEvsWorkplanModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
